import { Outlet } from 'react-router-dom';
import { PublicHeader } from './PublicHeader';
import { PublicFooter } from './PublicFooter';

export function PublicLayout(): JSX.Element {
  return (
    <div className="min-h-screen">
      <PublicHeader />
      <main className="mx-auto w-full max-w-6xl px-4 py-16 sm:px-6 sm:py-24">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
